import React, { type ReactNode } from "react";

import { CalendarCheckIcon } from "@/components/icons";
import { PanelHeaderAction } from "@/components/ui/PanelHeaderAction";
import { PLATFORM_REGISTRY } from "@/config/platforms";

import { panelTitle, type PanelId } from "../canvas/panels";
import { GROWTH_ICON } from "./GrowthPanel";
import { platformIcon } from "./PlatformCard";
import { ReportPanel, ReportPanelEmpty } from "./ReportPanel";
import { SOCIAL_PANEL_ICON } from "./SocialPanels";

const platformBadge = (key: string): ReactNode => {
  const config = PLATFORM_REGISTRY[key];
  return config ? platformIcon(config) : undefined;
};

/** The badge each panel wears in Month mode, so it keeps it in a window. */
const ICON: Partial<Record<PanelId, ReactNode>> = {
  growth: GROWTH_ICON,
  ...SOCIAL_PANEL_ICON,
  facebook: platformBadge("facebook"),
  instagram: platformBadge("instagram"),
  tiktok: platformBadge("tiktok"),
};

/** A panel whose data is the monthly social report, in window mode: it says
 *  so and offers Month (DD-005), never a figure from a part month. Folded in
 *  the rail it is one line, "Overview  by month", that still opens it. */
export const MonthOnlyPanel: React.FC<{ id: PanelId; onMonth(): void }> = ({ id, onMonth }) => {
  const title = panelTitle(id);
  return (
    <ReportPanel
      title={title}
      icon={ICON[id]}
      // No figure: the rail shows the header alone, this label beside the title.
      headlineLabel="by month"
      actions={
        <PanelHeaderAction label="Month" icon={<CalendarCheckIcon className="w-4 h-4" />} onClick={onMonth} />
      }
    >
      <ReportPanelEmpty message={`${title} reads by month.`} hint="Open Month to see it for a calendar month." />
    </ReportPanel>
  );
};
